import type { User } from '@/core/domain';
import type { UserRepository } from '../repositories/user-repository';

export class UpdateUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(id: string, user: Partial<User>): Promise<User> {
    return this.repository.update(id, user);
  }
}
